// extracted by mini-css-extract-plugin
export default {"root":"t0vdJAWasN3MBOEgxy7i","frame":"_a6zY4FTBGSZfpqRBwvx","placeHolderShimmer":"pBZjloyuEL58o1UADBmw"};